import React, { createContext, useContext, useState, useEffect } from 'react';
import topArrow from './../assets/images/up-arrow-50.png'; // Import the arrow image
import { isAndroid } from './../utils/deviceDetection';

const LayoutContext = createContext();
const isAndroidDevice = isAndroid();

export function useLayout() {
    return useContext(LayoutContext);
}

const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
};

export const LayoutProvider = ({ children }) => {
    const [isNavExpanded, setIsNavExpanded] = useState(false);
    const [showTopButton, setShowTopButton] = useState(false);

    const toggleNav = () => {
        setIsNavExpanded(prev => !prev);
    };

    const handleScroll = () => {
        if (window.scrollY > 0) {
            setShowTopButton(true);
        } else {
            setShowTopButton(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <LayoutContext.Provider value={{ isNavExpanded, toggleNav }}>
            {children}
            {showTopButton && (
                <button onClick={scrollToTop} className={isAndroidDevice ? "android-top-button" : "top-button"}>
                    {/* <img src={topArrow} alt="Scroll to top" /> */} Scroll to Top
                </button>
            )}
        </LayoutContext.Provider>
    );
};
